import React, { Component } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import PropTypes from 'prop-types';
import './saveState.css';
import { setIsActive } from './../../../../redux/actions/entities/pages';
import { saveState } from './../../../../redux/actions/entities/io';
import { isOrder } from './../../../../redux/actions/ui/isOrder';
import { placeCard, isLetterOfInvitation } from '../../../../helpers/weddingHelper';

import {
  getMinimumSheets,
  configExist,
} from './../../../../redux/helpers/';
import {
  getParam,
  getDomain,
} from './../../../../redux/helpers/getParams';


class SaveState extends Component {
  constructor(...args) {
    super(...args);
    this.saveState = this.saveState.bind(this);
    this.orderNow = this.orderNow.bind(this);
    this.folderId = 0;
    this.bookId = getParam('productId');
    this.referer = getDomain();
    this.ORDER_NOW_URL = '';
    const referer = getDomain();
    this.getStateURL = configExist('getStateUrl', referer);
    this.DELETE_TEXT_URL = `${this.getStateURL}/${this.bookId}/textimageclear`;
    this.continue = false;
    this.loaded = 'loaded';
    this.order = false;
  }

  componentDidUpdate(prevProps) {
    const { folderId } = this.props.state.bookProperties;
    const { folderId: prevFolderId } = prevProps.state.bookProperties;

    const referer = getDomain();
    if (folderId !== prevFolderId) {
      this.folderId = folderId;
      const legacyFolder = configExist('legacyFolder', referer);
      this.ORDER_NOW_URL = `${legacyFolder}&id=${this.folderId}`;
    }
  }

  checkPagesAreViewed() {
    /*  if (this.props.state.editorUI.isSavedBook) {
      return true;
    } */

    const lenghtOfPages = parseInt(this.props.state.entities.pages.allIds.length, 10);
    const viewedPages = this.props.state.editorUI.addPageToViewed;
    const lengthOfViewedPages = parseInt(Object.keys(viewedPages).length, 10);

    return lenghtOfPages === lengthOfViewedPages;
  }

  checkMinimumPages = () => {
    const { allIds } = this.props.state.entities.pages;
    if (allIds.slice(1).length < getMinimumSheets()) {
      return false;
    }
    return true;
  }

  deleteTexts = (texts) => {
    const textImages = Object.values(texts).map(element => 'image' in element.images.thumbnail && element.images.thumbnail.image);
    const url = this.DELETE_TEXT_URL;
    const data = { texts: textImages };


    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => res.json())
      .then(response => console.log('Success:', response))
      .catch(error => console.error('Error:', error));
  }

  preloader = () => <svg width="15" className="savePreloader" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g fill="none" fillRule="evenodd"><g transform="translate(1 1)" strokeWidth="2"><circle strokeOpacity=".5" cx="18" cy="18" r="18" /><path d="M36 18c0-9.94-8.06-18-18-18" /></g></g></svg>
  clockIcon = () => <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,15a7,7,0,1,1,7-7A7,7,0,0,1,8,15ZM8.5,3.5h-1v5h5v-1h-4Z" /></svg>
  cartIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M10 19.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm1.336-5l1.977-7h-16.813l2.938 7h11.898zm4.969-10l-3.432 12h-12.597l.839 2h13.239l3.474-12h1.929l.743-2h-4.195z" /></svg>

  orderNow() {
    const { lang, state } = this.props;
    const { texts } = state.entities;

    const { entities } = state;
    const getActivePage = Object.values(entities.pages.byId).find(el => el.isActive);
    const getLayoutType = entities.layouts.byId[getActivePage.layout].type;
    const type = 'error';

    const isInvitation = isLetterOfInvitation(getLayoutType);

    if (isInvitation && !this.checkPagesAreViewed() && !this.props.state.editorUI.isSavedBook) {
      const title = lang.title_notice;
      const message = lang.checkInvitationPages;
      return swal(title, message, type);
    }

    if (this.checkPagesAreViewed()) {
      this.continue = true;
      this.deleteTexts(texts);
      this.order = true;
      this.saveState();
      return true;
    }


    const title = lang.title_notice;
    const message = lang.check_before_order;
    return swal(title, message, type);
  }


  saveState() {
    const bookId = getParam('productId');
    const referer = getDomain();

    const clearPreviewUrl = configExist('clearThumbnailURL', referer);
    const clearUrl = `${clearPreviewUrl}/${bookId}`;
    const { previewFinished } = this.props.state.editorUI;

    fetch(clearUrl, {
      cors: 'no-cors',
      credentials: 'include',
    }).then(result => result.json())
      .then(() => {
        this.props.dispatch(isOrder(true));
        this.props.dispatch(setIsActive(10));
        this.props.dispatch(saveState());


        if (previewFinished === 'finished') {
          window.location.href = this.ORDER_NOW_URL;
        }
      });
  }

  render() {
    const {
      lang,
      bookId,
    } = this.props;
    const { isLoading } = this.props.state.entities.io.fetchState;

    const demoBookId = 0;
    if (bookId === demoBookId) {
      return false;
    }

    return (
      <div>
        <button className="btn green-btn save-state" onClick={this.orderNow}>
          { isLoading && this.order ? this.preloader() : this.cartIcon() }
          { lang.top_menu_order }
        </button>
      </div>
    );
  }
}

SaveState.defaultProps = {
  lang: {},
  folderId: 0,
  state: {},
  isLoading: false,
  bookId: 1,
  dispatch: () => {},
};

SaveState.propTypes = {
  lang: PropTypes.object,
  folderId: PropTypes.number,
  state: PropTypes.object,
  isLoading: PropTypes.bool,
  bookId: PropTypes.number,
  dispatch: PropTypes.func,
};

export default connect(state => ({
  state,
}))(SaveState);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/save-state/saveState.jsx